"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// ../../node_modules/.pnpm/cookie@0.6.0/node_modules/cookie/index.js
var require_cookie = __commonJS({
  "../../node_modules/.pnpm/cookie@0.6.0/node_modules/cookie/index.js"(exports) {
    "use strict";
    exports.parse = parse;
    exports.serialize = serialize;
    var __toString = Object.prototype.toString;
    var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
    function parse(str, options) {
      if (typeof str !== "string") {
        throw new TypeError("argument str must be a string");
      }
      var obj = {};
      var opt = options || {};
      var dec = opt.decode || decode;
      var index = 0;
      while (index < str.length) {
        var eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) {
          break;
        }
        var endIdx = str.indexOf(";", index);
        if (endIdx === -1) {
          endIdx = str.length;
        } else if (endIdx < eqIdx) {
          index = str.lastIndexOf(";", eqIdx - 1) + 1;
          continue;
        }
        var key = str.slice(index, eqIdx).trim();
        if (void 0 === obj[key]) {
          var val = str.slice(eqIdx + 1, endIdx).trim();
          if (val.charCodeAt(0) === 34) {
            val = val.slice(1, -1);
          }
          obj[key] = tryDecode(val, dec);
        }
        index = endIdx + 1;
      }
      return obj;
    }
    function serialize(name, val, options) {
      var opt = options || {};
      var enc = opt.encode || encode;
      if (typeof enc !== "function") {
        throw new TypeError("option encode is invalid");
      }
      if (!fieldContentRegExp.test(name)) {
        throw new TypeError("argument name is invalid");
      }
      var value = enc(val);
      if (value && !fieldContentRegExp.test(value)) {
        throw new TypeError("argument val is invalid");
      }
      var str = name + "=" + value;
      if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) {
          throw new TypeError("option maxAge is invalid");
        }
        str += "; Max-Age=" + Math.floor(maxAge);
      }
      if (opt.domain) {
        if (!fieldContentRegExp.test(opt.domain)) {
          throw new TypeError("option domain is invalid");
        }
        str += "; Domain=" + opt.domain;
      }
      if (opt.path) {
        if (!fieldContentRegExp.test(opt.path)) {
          throw new TypeError("option path is invalid");
        }
        str += "; Path=" + opt.path;
      }
      if (opt.expires) {
        var expires = opt.expires;
        if (!isDate(expires) || isNaN(expires.valueOf())) {
          throw new TypeError("option expires is invalid");
        }
        str += "; Expires=" + expires.toUTCString();
      }
      if (opt.httpOnly) {
        str += "; HttpOnly";
      }
      if (opt.secure) {
        str += "; Secure";
      }
      if (opt.partitioned) {
        str += "; Partitioned";
      }
      if (opt.priority) {
        var priority = typeof opt.priority === "string" ? opt.priority.toLowerCase() : opt.priority;
        switch (priority) {
          case "low":
            str += "; Priority=Low";
            break;
          case "medium":
            str += "; Priority=Medium";
            break;
          case "high":
            str += "; Priority=High";
            break;
          default:
            throw new TypeError("option priority is invalid");
        }
      }
      if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch (sameSite) {
          case true:
            str += "; SameSite=Strict";
            break;
          case "lax":
            str += "; SameSite=Lax";
            break;
          case "strict":
            str += "; SameSite=Strict";
            break;
          case "none":
            str += "; SameSite=None";
            break;
          default:
            throw new TypeError("option sameSite is invalid");
        }
      }
      return str;
    }
    function decode(str) {
      return str.indexOf("%") !== -1 ? decodeURIComponent(str) : str;
    }
    function encode(val) {
      return encodeURIComponent(val);
    }
    function isDate(val) {
      return __toString.call(val) === "[object Date]" || val instanceof Date;
    }
    function tryDecode(str, decode2) {
      try {
        return decode2(str);
      } catch (e) {
        return str;
      }
    }
  }
});

// ../../node_modules/.pnpm/lodash.mapvalues@4.6.0/node_modules/lodash.mapvalues/index.js
var require_lodash = __commonJS({
  "../../node_modules/.pnpm/lodash.mapvalues@4.6.0/node_modules/lodash.mapvalues/index.js"(exports, module2) {
    "use strict";
    var LARGE_ARRAY_SIZE = 200;
    var FUNC_ERROR_TEXT = "Expected a function";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var UNORDERED_COMPARE_FLAG = 1;
    var PARTIAL_COMPARE_FLAG = 2;
    var INFINITY = 1 / 0;
    var MAX_SAFE_INTEGER = 9007199254740991;
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var objectTag = "[object Object]";
    var promiseTag = "[object Promise]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var symbolTag = "[object Symbol]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
    var reIsPlainProp = /^\w*$/;
    var reLeadingDot = /^\./;
    var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reEscapeChar = /\\(\\)?/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module2 == "object" && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        return freeProcess && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function arraySome(array, predicate) {
      var index = -1, length = array ? array.length : 0;
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }
    function baseProperty(key) {
      return function(object) {
        return object == null ? void 0 : object[key];
      };
    }
    function baseTimes(n, iteratee) {
      var index = -1, result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    function isHostObject(value) {
      var result = false;
      if (value != null && typeof value.toString != "function") {
        try {
          result = !!(value + "");
        } catch (e) {
        }
      }
      return result;
    }
    function mapToArray(map) {
      var index = -1, result = Array(map.size);
      map.forEach(function(value, key) {
        result[++index] = [key, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function setToArray(set) {
      var index = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index] = value;
      });
      return result;
    }
    var arrayProto = Array.prototype;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var coreJsData = root["__core-js_shared__"];
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var objectToString = objectProto.toString;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    var Symbol2 = root.Symbol;
    var Uint8Array2 = root.Uint8Array;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var splice = arrayProto.splice;
    var nativeKeys = overArg(Object.keys, Object);
    var DataView = getNative(root, "DataView");
    var Map2 = getNative(root, "Map");
    var Promise2 = getNative(root, "Promise");
    var Set2 = getNative(root, "Set");
    var WeakMap2 = getNative(root, "WeakMap");
    var nativeCreate = getNative(Object, "create");
    var dataViewCtorString = toSource(DataView);
    var mapCtorString = toSource(Map2);
    var promiseCtorString = toSource(Promise2);
    var setCtorString = toSource(Set2);
    var weakMapCtorString = toSource(WeakMap2);
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    var symbolToString = symbolProto ? symbolProto.toString : void 0;
    function Hash(entries) {
      var index = -1, length = entries ? entries.length : 0;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
    }
    function hashDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    function hashSet(key, value) {
      var data = this.__data__;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    function ListCache(entries) {
      var index = -1, length = entries ? entries.length : 0;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function listCacheClear() {
      this.__data__ = [];
    }
    function listCacheDelete(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      return true;
    }
    function listCacheGet(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    }
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    function listCacheSet(key, value) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    function MapCache(entries) {
      var index = -1, length = entries ? entries.length : 0;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function mapCacheClear() {
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    function mapCacheDelete(key) {
      return getMapData(this, key)["delete"](key);
    }
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    function mapCacheSet(key, value) {
      getMapData(this, key).set(key, value);
      return this;
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    function SetCache(values) {
      var index = -1, length = values ? values.length : 0;
      this.__data__ = new MapCache();
      while (++index < length) {
        this.add(values[index]);
      }
    }
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }
    function setCacheHas(value) {
      return this.__data__.has(value);
    }
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    function Stack(entries) {
      this.__data__ = new ListCache(entries);
    }
    function stackClear() {
      this.__data__ = new ListCache();
    }
    function stackDelete(key) {
      return this.__data__["delete"](key);
    }
    function stackGet(key) {
      return this.__data__.get(key);
    }
    function stackHas(key) {
      return this.__data__.has(key);
    }
    function stackSet(key, value) {
      var cache = this.__data__;
      if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          return this;
        }
        cache = this.__data__ = new MapCache(pairs);
      }
      cache.set(key, value);
      return this;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    function arrayLikeKeys(value, inherited) {
      var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
      var length = result.length, skipIndexes = !!length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    var baseFor = createBaseFor();
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }
    function baseGet(object, path) {
      path = isKey(path, object) ? [path] : castPath(path);
      var index = 0, length = path.length;
      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return index && index == length ? object : void 0;
    }
    function baseGetTag(value) {
      return objectToString.call(value);
    }
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }
    function baseIsEqual(value, other, customizer, bitmask, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || !isObject(value) && !isObjectLike(other)) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
    }
    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
      var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
      if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
      }
      if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
      }
      var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
      }
      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack());
          return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack());
      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
    }
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length, length = index, noCustomizer = !customizer;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
          if (objValue === void 0 && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack();
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === void 0 ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) {
            return false;
          }
        }
      }
      return true;
    }
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
    }
    function baseIteratee(value) {
      if (typeof value == "function") {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == "object") {
        return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
      }
      return property(value);
    }
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != "constructor") {
          result.push(key);
        }
      }
      return result;
    }
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, void 0, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
      };
    }
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }
    function baseToString(value) {
      if (typeof value == "string") {
        return value;
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : "";
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    function castPath(value) {
      return isArray(value) ? value : stringToPath(value);
    }
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }
    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache() : void 0;
      stack.set(array, other);
      stack.set(other, array);
      while (++index < arrLength) {
        var arrValue = array[index], othValue = other[index];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== void 0) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        if (seen) {
          if (!arraySome(other, function(othValue2, othIndex) {
            if (!seen.has(othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
          result = false;
          break;
        }
      }
      stack["delete"](array);
      stack["delete"](other);
      return result;
    }
    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
      switch (tag) {
        case dataViewTag:
          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          return eq(+object, +other);
        case errorTag:
          return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
          return object == other + "";
        case mapTag:
          var convert = mapToArray;
        case setTag:
          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
          convert || (convert = setToArray);
          if (object.size != other.size && !isPartial) {
            return false;
          }
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= UNORDERED_COMPARE_FLAG;
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
          stack["delete"](object);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }
    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);
      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        }
        if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == "constructor");
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack["delete"](object);
      stack["delete"](other);
      return result;
    }
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    function getMatchData(object) {
      var result = keys(object), length = result.length;
      while (length--) {
        var key = result[length], value = object[key];
        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    var getTag = baseGetTag;
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
      getTag = function(value) {
        var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : void 0;
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    function hasPath(object, path, hasFunc) {
      path = isKey(path, object) ? [path] : castPath(path);
      var result, index = -1, length = path.length;
      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result) {
        return result;
      }
      var length = object ? object.length : 0;
      return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
    }
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (typeof value == "number" || reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
    }
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
      };
    }
    var stringToPath = memoize2(function(string) {
      string = toString(string);
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push("");
      }
      string.replace(rePropName, function(match, number, quote, string2) {
        result.push(quote ? string2.replace(reEscapeChar, "$1") : number || match);
      });
      return result;
    });
    function toKey(value) {
      if (typeof value == "string" || isSymbol(value)) {
        return value;
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    function memoize2(func, resolver) {
      if (typeof func != "function" || resolver && typeof resolver != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new (memoize2.Cache || MapCache)();
      return memoized;
    }
    memoize2.Cache = MapCache;
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    function isArguments(value) {
      return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
    }
    var isArray = Array.isArray;
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    function isFunction(value) {
      var tag = isObject(value) ? objectToString.call(value) : "";
      return tag == funcTag || tag == genTag;
    }
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    function isObject(value) {
      var type = typeof value;
      return !!value && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return !!value && typeof value == "object";
    }
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    function toString(value) {
      return value == null ? "" : baseToString(value);
    }
    function get(object, path, defaultValue) {
      var result = object == null ? void 0 : baseGet(object, path);
      return result === void 0 ? defaultValue : result;
    }
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    function mapValues2(object, iteratee) {
      var result = {};
      iteratee = baseIteratee(iteratee, 3);
      baseForOwn(object, function(value, key, object2) {
        result[key] = iteratee(value, key, object2);
      });
      return result;
    }
    function identity(value) {
      return value;
    }
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }
    module2.exports = mapValues2;
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  getLanguageFromPath: () => getLanguageFromPath,
  getOrigin: () => getOrigin,
  parseUrl: () => parseUrl,
  parseUrlWithForcedSite: () => parseUrlWithForcedSite,
  route: () => route
});
module.exports = __toCommonJS(src_exports);

// ../../internal-packages/common-types/src/index.ts
var istioGateways = {
  development: "origin.ap-southeast-2.development.external.seekinfra.com",
  production: "origin.ap-southeast-2.production.external.seekinfra.com"
};

// ../../internal-packages/util-functions/src/join-paths.ts
var joinPaths = (segments, options) => {
  let joinedPath = "";
  for (const segment of segments) {
    if (!segment || segment === "/") {
      continue;
    }
    let newSegment = segment;
    if (newSegment[0] === "/") {
      newSegment = newSegment.slice(1);
    }
    if (newSegment[newSegment.length - 1] === "/") {
      newSegment = newSegment.slice(0, -1);
    }
    joinedPath += `${newSegment}/`;
  }
  if (options == null ? void 0 : options.leading) {
    joinedPath = `/${joinedPath}`;
  }
  if (!(options == null ? void 0 : options.trailing)) {
    joinedPath = joinedPath.slice(0, -1);
  }
  let doubleSlashIndex = joinedPath.indexOf("//");
  while (doubleSlashIndex !== -1) {
    joinedPath = joinedPath.replace("//", "/");
    doubleSlashIndex = joinedPath.indexOf("//");
  }
  return joinedPath;
};

// ../../internal-packages/util-functions/src/memoize.ts
var memoize = (fn) => {
  let value;
  return () => value ??= fn();
};

// ../../internal-packages/util-functions/src/object-from-entries.ts
var objectFromEntries = (entries) => Object.fromEntries(entries);

// ../../internal-packages/util-functions/src/weak-map-value.ts
var weakMapValue = (map, key, fn) => map.get(key) ?? setWeakMapValue(map, key, fn());
var setWeakMapValue = (map, key, value) => {
  map.set(key, value);
  return value;
};

// ../../internal-packages/request-context/src/cookies.ts
var import_cookie = __toESM(require_cookie());
var context = /* @__PURE__ */ new WeakMap();
var getCookies = (request) => weakMapValue(
  context,
  request,
  () => (0, import_cookie.parse)(request.headers.get("cookie") ?? "")
);
var getCookieValue = (request, cookieName) => getCookies(request)[cookieName] ?? null;

// ../../internal-packages/request-context/src/jobseeker-cookies.ts
var context2 = /* @__PURE__ */ new WeakMap();
var jobseekerCookieNames = [
  "JobseekerSessionId",
  "JobseekerVisitorId"
];
var getJobseekerCookies = (request) => weakMapValue(context2, request, () => {
  const cookies = getCookies(request);
  const uuid = memoize(() => crypto.randomUUID());
  return objectFromEntries(
    jobseekerCookieNames.map(
      (jobseekerCookieName) => [
        jobseekerCookieName,
        cookies[jobseekerCookieName] ?? uuid()
      ]
    )
  );
});
var getJobseekerCookie = (request, jobseekerCookieName) => getJobseekerCookies(request)[jobseekerCookieName];

// ../../internal-packages/internal-config/src/maintenance/index.ts
var import_lodash = __toESM(require_lodash());

// ../../internal-packages/internal-config/src/maintenance/retry-after.ts
var minRetryAfter = 20 * 60;
var maxRetryAfter = 5 * 60 * 60;
var getRetryAfterHeaderValue = (maintenanceConfig2) => {
  const retryAfter = maintenanceConfig2 == null ? void 0 : maintenanceConfig2.retryAfter;
  if (retryAfter === void 0) {
    return `${minRetryAfter}`;
  }
  const retryAfterValue = Math.round((retryAfter - Date.now()) / 1e3);
  if (retryAfterValue < minRetryAfter) {
    return `${minRetryAfter}`;
  }
  if (retryAfterValue > maxRetryAfter) {
    return `${maxRetryAfter}`;
  }
  return `${retryAfterValue}`;
};

// ../../internal-packages/internal-config/src/maintenance/index.ts
var seed = "melways-maintenance-seed-A324D3ED-FC55-4CFA-BDC7-CD57C8008C69";
var thresholdSize = 3;
var maxMaintenanceThreshold = 2 ** (thresholdSize * 8) - 1;
var getMaintenanceValue = async (request) => {
  const jobseekerVisitorId = getJobseekerCookie(request, "JobseekerVisitorId");
  const hash = new Uint8Array(
    await crypto.subtle.digest(
      { name: "SHA-1" },
      new TextEncoder().encode(`${jobseekerVisitorId}${seed}`)
    )
  );
  let result = hash[0];
  for (let i = 1; i < thresholdSize; i++) {
    result = (result << 8) + hash[i];
  }
  return result;
};

// src/index.ts
var import_melways_sites5 = require("@seek/melways-sites");

// src/consolidation.ts
var import_melways_sites = require("@seek/melways-sites");
var consolidatedLaunchedCookie = "MELWAYS_CONSOLIDATED_LAUNCHED";
var consolidatedLaunchedHeader = "melways-consolidated-launched";
var consolidatedLaunchedParam = "melways-consolidated-launched";
var shouldRedirect = (origin) => origin.type !== "api";
var launchedOverride = (request, url) => getCookieValue(request, consolidatedLaunchedCookie) || request.headers.get(consolidatedLaunchedHeader) || url.searchParams.get(consolidatedLaunchedParam);
var isLaunched = (request, url, site) => {
  switch (launchedOverride(request, url)) {
    case "false":
    case `!${site}`:
      return false;
    case "true":
    case site:
      return true;
    default:
      return import_melways_sites.consolidationConfig[site].launched;
  }
};
var getRedirectSite = (request, url, site) => {
  const { consolidated, sitePair } = import_melways_sites.consolidationConfig[site];
  if (!sitePair) {
    return;
  }
  const { nonConsolidatedSite, consolidatedSite } = sitePair;
  const launched = isLaunched(request, url, consolidatedSite);
  if (consolidated && !launched) {
    return nonConsolidatedSite;
  }
  if (!consolidated && launched) {
    return consolidatedSite;
  }
};
var getConsolidationRedirectUrl = (request, url, hostConfig, origin) => {
  if (!shouldRedirect(origin))
    return;
  const redirectSite = getRedirectSite(request, url, hostConfig.site);
  if (!redirectSite) {
    return;
  }
  const redirectUrl = new URL(url.toString());
  redirectUrl.host = hostConfig.environment === "production" ? import_melways_sites.siteConfig[redirectSite].host : import_melways_sites.siteConfig[redirectSite].stagingHost;
  deleteConsolidatedLaunchedParam(redirectUrl);
  return redirectUrl;
};
var deleteConsolidatedLaunchedParam = (url) => {
  if (url.searchParams.has(consolidatedLaunchedParam)) {
    url.searchParams.delete(consolidatedLaunchedParam);
  }
};

// src/error-status.ts
var errorStatusByType = {
  forbidden: 403,
  "not-found": 404,
  "server-error": 500,
  maintenance: 503
};
var getErrorTypeByStatus = (status) => {
  switch (status) {
    case 403: {
      return "forbidden";
    }
    case 404: {
      return "not-found";
    }
    default: {
      return "server-error";
    }
  }
};

// ../../internal-packages/config-functions/src/trailing-slash-redirect.ts
var isNestedPathname = (pathname) => {
  const secondSlashIndex = pathname.indexOf("/", 1);
  return secondSlashIndex !== -1 && secondSlashIndex !== pathname.length - 1;
};
var normalizePathForTrailingSlashRedirect = (pathname, policy) => {
  if (policy === "DISABLE" || pathname === "/") {
    return pathname;
  }
  const hasTrailingSlash = pathname.endsWith("/");
  if (hasTrailingSlash) {
    if (policy === "STRIP_TRAILING_SLASH" || policy === "EXPECT_TRAILING_SLASH_ONLY_TOP_LEVEL" && isNestedPathname(pathname)) {
      return pathname.slice(0, -1);
    }
  } else if (policy === "EXPECT_TRAILING_SLASH" || policy === "EXPECT_TRAILING_SLASH_ONLY_TOP_LEVEL" && !isNestedPathname(pathname)) {
    return `${pathname}/`;
  }
  return pathname;
};

// ../../internal-packages/request-match/src/index.ts
var rootMatch = "_root";
var paramMatch = "_param";
var wildcardMatch = "_wildcard";
var extractPathSegments = (path) => {
  const segments = path.split("/");
  if (segments.at(0) === "") {
    segments.shift();
  }
  if (segments.at(-1) === "") {
    segments.pop();
  }
  return segments;
};
var paramMatchRegex = /(?::|\$)(\w+)/g;
var parseSegmentParams = (pathSegment) => {
  const paramNames = Array.from(pathSegment.matchAll(paramMatchRegex)).map(
    ([param]) => param.slice(1)
  );
  const match = pathSegment.replaceAll(paramMatchRegex, `(.+)`);
  return { paramNames, match, specificity: match.length };
};
var createExamplePath = (pathname, paramReplacer) => {
  const examplePath = extractPathSegments(pathname).map(
    (segment) => segment.replaceAll(paramMatchRegex, (_, param) => paramReplacer(param)).replace("*", "wildcard")
  ).join("/");
  const hasTrailingSlash = pathname.length > 1 && pathname.endsWith("/");
  return `/${examplePath}${hasTrailingSlash ? "/" : ""}`;
};
var checkCondition = (_url, request, condition) => {
  const value = condition.type === "cookie" ? getCookieValue(request, condition.key) : request.headers.get(condition.key);
  const valueExists = typeof value === "string";
  if ("exists" in condition) {
    return condition.exists && valueExists || !condition.exists && !valueExists;
  }
  return valueExists ? new RegExp(condition.regex).test(value) : false;
};
var reverseFind = (list, fn) => {
  for (let i = list.length - 1; i >= 0; i--) {
    if (fn(list[i])) {
      return list[i];
    }
  }
};
var RequestMatcher = class {
  matches;
  dataLookup;
  constructor(initialState) {
    this.matches = (initialState == null ? void 0 : initialState.matches) ?? {};
    this.dataLookup = (initialState == null ? void 0 : initialState.dataLookup) ?? [];
  }
  register({
    match,
    conditions,
    data
  }) {
    var _a, _b;
    const pathSegments = extractPathSegments(match);
    const finalSegment = pathSegments[pathSegments.length - 1] === "*" ? wildcardMatch : rootMatch;
    if (finalSegment === wildcardMatch) {
      pathSegments.pop();
    }
    const paramNames = [];
    let currSegmentMatch = this.matches;
    for (const segment of pathSegments) {
      const isParamMatch = segment.includes(":") || segment.includes("$");
      if (isParamMatch) {
        const segmentParams = parseSegmentParams(segment);
        paramNames.push(...segmentParams.paramNames);
        const currParamMatch = currSegmentMatch[paramMatch] ||= [];
        let paramMatchInfo = currParamMatch.find(
          ({ regexp }) => regexp === segmentParams.match
        );
        if (!paramMatchInfo) {
          paramMatchInfo = {
            regexp: segmentParams.match,
            matches: {},
            specificity: segmentParams.specificity
          };
          currParamMatch.push(paramMatchInfo);
          currParamMatch.sort((a, b) => b.specificity - a.specificity);
        }
        currSegmentMatch = paramMatchInfo.matches;
      } else {
        if (!currSegmentMatch[segment]) {
          currSegmentMatch[segment] = {};
        }
        currSegmentMatch = currSegmentMatch[segment];
      }
    }
    const matchId = this.dataLookup.push({
      data,
      paramNames,
      conditions
    }) - 1;
    if (currSegmentMatch[finalSegment]) {
      (_a = currSegmentMatch[finalSegment]) == null ? void 0 : _a.push(matchId);
      (_b = currSegmentMatch[finalSegment]) == null ? void 0 : _b.sort(
        (a, b) => {
          var _a2, _b2;
          return (((_a2 = this.dataLookup[a].conditions) == null ? void 0 : _a2.length) ?? 0) - (((_b2 = this.dataLookup[b].conditions) == null ? void 0 : _b2.length) ?? 0);
        }
      );
    } else {
      currSegmentMatch[finalSegment] = [matchId];
    }
  }
  matchesConditions(matchId, url, request) {
    const { conditions } = this.dataLookup[matchId];
    return conditions ? conditions.every((condition) => checkCondition(url, request, condition)) : true;
  }
  match(url, request) {
    const path = url.pathname;
    const segments = extractPathSegments(path);
    let currSegmentMatch = this.matches;
    const wildcardMatches = [];
    const params = [];
    for (let i = 0; i < segments.length; i++) {
      if (!currSegmentMatch) {
        break;
      }
      if (currSegmentMatch[wildcardMatch]) {
        for (const wildcardMatchId of currSegmentMatch[wildcardMatch]) {
          wildcardMatches.push({
            matchId: wildcardMatchId,
            pathIndex: i
          });
        }
      }
      const segment = segments[i];
      if (segment in currSegmentMatch) {
        currSegmentMatch = currSegmentMatch[segment];
        continue;
      }
      const paramMatches = currSegmentMatch[paramMatch];
      if (paramMatches) {
        let paramSegmentMatch;
        for (const paramMatchInfo of paramMatches) {
          const paramMatchResult = segment.match(
            new RegExp(paramMatchInfo.regexp)
          );
          if (paramMatchResult) {
            for (const matchGroup of paramMatchResult.slice(1)) {
              params.push(matchGroup);
            }
            paramSegmentMatch = paramMatchInfo.matches;
            break;
          }
        }
        if (paramSegmentMatch) {
          currSegmentMatch = paramSegmentMatch;
          continue;
        }
      }
      currSegmentMatch = null;
    }
    let isExactMatch = false;
    let matchId;
    let wildcardPathMatch;
    if (currSegmentMatch && Array.isArray(currSegmentMatch[rootMatch])) {
      const potentialMatchId = reverseFind(
        currSegmentMatch[rootMatch],
        (currMatchId) => this.matchesConditions(currMatchId, url, request)
      );
      if (typeof potentialMatchId === "number") {
        isExactMatch = true;
        matchId = potentialMatchId;
      }
    }
    if (!isExactMatch) {
      const potentialWildcardMatch = reverseFind(
        wildcardMatches,
        (currWildcardMatch) => this.matchesConditions(currWildcardMatch.matchId, url, request)
      );
      if (potentialWildcardMatch) {
        matchId = potentialWildcardMatch.matchId;
        wildcardPathMatch = segments.slice(potentialWildcardMatch.pathIndex).join("/");
      }
    }
    if (typeof matchId === "number") {
      const { data, paramNames } = this.dataLookup[matchId];
      const paramEntries = paramNames.map((name, index) => [name, params[index]]).concat();
      if (wildcardPathMatch) {
        paramEntries.push([wildcardMatch, wildcardPathMatch]);
      }
      return {
        data,
        params: Object.fromEntries(paramEntries)
      };
    }
    return null;
  }
  exportState() {
    return {
      dataLookup: this.dataLookup,
      matches: this.matches
    };
  }
};

// src/get-origin.ts
var import_melways_sites3 = require("@seek/melways-sites");

// src/browser-upgrade.ts
var browserAgeMap = /* @__PURE__ */ new Map([
  [/ms-office/, "modern"],
  [/Mozilla\/5\.0\s.+(bot|spider)/i, "modern"],
  [/Edge\/1[0-5](?:[\d\.]+)?/, "outdated"],
  [/SamsungBrowser\/[0-4]\b(?:[\d\.]+)?/, "outdated"],
  [/Version\/(?:[0-8]\b|9\.0)(?:[\d\.]+)?\sSafari/, "outdated"],
  [
    /Version\/(?:[0-8]\b|9\.[0-2])(?:[\d\.]+)?\sMobile\/\S+\sSafari/,
    "outdated"
  ],
  [/Mozilla.*Firefox\/0\./, "outdated"],
  [/Mozilla.*Firefox\/1\.[0-5]\./, "outdated"],
  [/IE [1-9]\./, "outdated"],
  [/MSIE 10\./, "outdated"],
  [/rv:11\./, "outdated"]
]);
var getBrowserAge = (userAgent) => {
  for (const [regexp, age] of browserAgeMap.entries()) {
    const result = regexp.exec(userAgent);
    if (result) {
      return age;
    }
  }
  return "modern";
};
var isRequestFromOutdatedBrowser = (request) => {
  const userAgent = request.headers.get("user-agent");
  const browserAge = userAgent ? getBrowserAge(userAgent) : "modern";
  return browserAge === "outdated";
};
var requestHasBrowserUpgradeBypassCookie = (request) => Boolean(getCookieValue(request, "UpdateBrowserMessage"));

// src/get-lang-from-path.ts
var getLanguageFromPath = (path, languages) => {
  if (path === "/" || path.indexOf("/") !== 0 || !languages) {
    return {
      pathWithoutLanguage: path
    };
  }
  const secondSlashIndex = path.indexOf("/", 1);
  const possibleLanguage = secondSlashIndex === -1 ? path.slice(1) : path.slice(1, path.indexOf("/", 1));
  if (languages.indexOf(possibleLanguage) === -1) {
    return {
      pathWithoutLanguage: path
    };
  }
  return {
    language: possibleLanguage,
    pathWithoutLanguage: secondSlashIndex === -1 ? "/" : path.slice(secondSlashIndex)
  };
};

// src/hreflang.ts
var import_melways_sites2 = require("@seek/melways-sites");
var langifyPath = (path, languages) => languages.map((language) => ({
  language,
  path: language !== import_melways_sites2.defaultLanguage ? joinPaths([language, path], {
    leading: true,
    trailing: path.endsWith("/")
  }) : path
}));
var createHreflangHeader = (url, expectedPathLanguage, siteLanguages) => {
  if (!siteLanguages.includes(expectedPathLanguage)) {
    throw new Error(
      `Error creating hreflang header: Expected language "${expectedPathLanguage}" doesn't exist in site languages: ${siteLanguages.map((lang) => `"${lang}"`).join(", ")}`
    );
  }
  const { language: derivedLanguage = import_melways_sites2.defaultLanguage, pathWithoutLanguage } = getLanguageFromPath(url.pathname, siteLanguages);
  if (derivedLanguage !== expectedPathLanguage) {
    throw new Error(
      `Error creating hreflang header: Derived language "${derivedLanguage}" does not match the expected language "${expectedPathLanguage}"`
    );
  }
  const langifiedPaths = langifyPath(pathWithoutLanguage, siteLanguages);
  return [
    "link",
    langifiedPaths.map(({ language, path }) => {
      const alternateUrl = `${url.origin}${path}${url.search}`;
      return `<${alternateUrl}>; rel="alternate"; hreflang="${language}"`;
    }).join(", ")
  ];
};

// src/log.ts
var logError = (errorInfo) => {
  console.error(errorInfo);
};
var logFields = (input) => {
  for (const [key, val] of Object.entries(input)) {
    if (key === "expectedToExist") {
      continue;
    }
    if (Array.isArray(val)) {
      for (const [subKey, subVal] of val) {
        console.log(`${key}.${subKey}=${subVal}`);
      }
    } else if (val !== void 0) {
      console.log(`${key}=${val}`);
    }
  }
};

// src/maintenance.ts
var maintenanceBypassCookie = "MELWAYS_MAINTENANCE_BYPASS";
var maintenanceBypassHeader = "melways-maintenance-bypass";
var maintenanceBypassParam = "melways-maintenance-bypass";
var seoUserAgentRegExp = /(googlebot|bingbot)/i;
var isMaintenanceShown = (origin) => {
  if (origin.type === "s3") {
    return origin.s3Url.endsWith("/index.html");
  }
  if (origin.type === "ssr") {
    return !(origin.pathname.endsWith("robots.txt") || origin.pathname.endsWith("ads.txt"));
  }
  return origin.type !== "redirect";
};
var hasBypassFlag = (request, url) => Boolean(
  getCookieValue(request, maintenanceBypassCookie) || request.headers.get(maintenanceBypassHeader) || url.searchParams.get(maintenanceBypassParam)
);
var getThresholdType = (request, origin) => {
  if (seoUserAgentRegExp.test(request.headers.get("user-agent") ?? "")) {
    return "seo";
  }
  if (origin.type === "api") {
    return "api";
  }
  return "web";
};
var shouldShowMaintenance = async (request, url, hostConfig, origin) => {
  if (!hostConfig.maintenance || !isMaintenanceShown(origin) || hasBypassFlag(request, url)) {
    return false;
  }
  const thresholdType = getThresholdType(request, origin);
  const threshold = hostConfig.maintenance.thresholds[thresholdType];
  if (threshold === maxMaintenanceThreshold) {
    return true;
  }
  if (threshold !== 0) {
    const maintenanceValue = await getMaintenanceValue(request);
    return maintenanceValue < threshold;
  }
  return false;
};
var deleteMaintenanceBypassParam = (url) => {
  if (url.searchParams.has(maintenanceBypassParam)) {
    url.searchParams.delete(maintenanceBypassParam);
  }
};

// src/simulate-page.ts
var errorTypes = [
  "not-found",
  "forbidden",
  "server-error",
  "maintenance"
];
var utilityPageTypes = ["browser-upgrade"];
var simulatePageTypes = /* @__PURE__ */ new Set([
  ...utilityPageTypes,
  ...errorTypes
]);
var simulatePageParam = "melways-simulate-page";
var getSimulatePageParam = (url) => {
  if (url.searchParams.has(simulatePageParam)) {
    const simulatePage = url.searchParams.get(simulatePageParam);
    if (simulatePageTypes.has(simulatePage)) {
      return simulatePage;
    }
  }
};
var deleteSimulatePageParam = (url) => {
  if (url.searchParams.has(simulatePageParam)) {
    url.searchParams.delete(simulatePageParam);
  }
};

// src/get-origin.ts
var region = "ap-southeast-2";
var createS3Url = (bucket, key) => `https://${bucket}.s3.${region}.amazonaws.com/${key}`;
var rewritePathname = (pathname, rewrite, routeParams) => {
  if (!rewrite) {
    return pathname;
  }
  if (rewrite.indexOf("*") === -1) {
    return rewrite;
  }
  if (!routeParams._wildcard) {
    throw new Error(
      `Can't rewrite path "${pathname}" to "${rewrite}" as no wildcard match was found`
    );
  }
  return rewrite.replace("*", routeParams._wildcard);
};
var resolveOrigin = (url, {
  origin,
  localized,
  language,
  pathRewrite,
  hreflangBehaviour
}, routeParams, environment, versionReplacementKey, languages) => {
  const responseHeaders = [];
  if (localized && hreflangBehaviour !== "disable" && languages.length > 1) {
    try {
      responseHeaders.push(createHreflangHeader(url, language, languages));
    } catch (e) {
      console.error(e);
    }
  }
  if (origin.type === "s3") {
    const version = url.searchParams.has("v") ? encodeURIComponent(
      encodeURIComponent(url.searchParams.get("v") || "current")
    ) : "current";
    const key = origin.bucketKey.replace(versionReplacementKey, version);
    return {
      type: origin.type,
      s3Url: createS3Url(origin.bucket, key),
      responseHeaders,
      expectedToExist: true
    };
  }
  if (origin.type === "api" || origin.type === "ssr") {
    return {
      ...origin,
      responseHeaders,
      environment,
      pathname: rewritePathname(url.pathname, pathRewrite, routeParams)
    };
  }
  return origin;
};
var generateErrorOrigin = (url, { errorPages, languages }, errorType, responseHeaders) => {
  const { language = import_melways_sites3.defaultLanguage } = getLanguageFromPath(
    url.pathname,
    languages
  );
  const { bucket, bucketKey } = errorPages[errorType][language];
  return {
    type: errorType,
    s3Url: createS3Url(bucket, bucketKey),
    ...responseHeaders ? { responseHeaders } : {}
  };
};
var shouldShowBrowserUpgradePage = (routeInfo, request, simulatePage) => simulatePage === "browser-upgrade" || routeInfo.enforceBrowserSupportPolicy && isRequestFromOutdatedBrowser(request) && !requestHasBrowserUpgradeBypassCookie(request);
var getOutputResponse = (hostConfig, url, request) => {
  var _a;
  const { replacementKeys, environment, routeData, languages } = hostConfig;
  const requestMatcher = new RequestMatcher(routeData);
  const result = requestMatcher.match(url, request);
  if (!result) {
    logError({
      message: `Unable to match URL ${url}`
    });
    return {
      response: generateErrorOrigin(url, hostConfig, "not-found")
    };
  }
  const { owner, appName } = result.data;
  const ownershipInfo = { owner, appName };
  if (result.data.type === "static-asset") {
    const { bucketName, bucketKeyPrefix } = result.data;
    const fileName = result.params._wildcard;
    if (!fileName) {
      logError({
        message: `Could not find static asset at ${url.pathname}`,
        ownershipInfo
      });
      return {
        response: generateErrorOrigin(url, hostConfig, "not-found"),
        ownershipInfo
      };
    }
    const bucketKey = bucketKeyPrefix ? `${bucketKeyPrefix}/${fileName}` : fileName;
    return {
      response: {
        type: "s3",
        s3Url: createS3Url(bucketName, bucketKey),
        responseHeaders: [["X-Robots-Tag", "noindex, nofollow"]],
        expectedToExist: false
      },
      ownershipInfo
    };
  }
  if (result.data.type === "redirect") {
    const newUrl = new URL(url.toString());
    if (result.data.host) {
      newUrl.hostname = result.data.host;
    }
    newUrl.pathname = createExamplePath(result.data.path, (param) => {
      if (!result.params.hasOwnProperty(param)) {
        throw new Error(
          `Redirect path can't be generated. Required param '${param}' was not found in source path '${url.pathname}'`
        );
      }
      return result.params[param];
    });
    return {
      response: {
        type: "redirect",
        url: newUrl.toString(),
        status: result.data.permanent ? 308 : 307
      },
      ownershipInfo
    };
  }
  if (result.data.type === "fallthrough") {
    return {
      response: {
        type: "fallthrough"
      },
      ownershipInfo
    };
  }
  const simulatePage = result.data.origin.type === "s3" || result.data.origin.type === "ssr" ? getSimulatePageParam(url) : void 0;
  if (shouldShowBrowserUpgradePage(result.data, request, simulatePage)) {
    const { language = import_melways_sites3.defaultLanguage } = getLanguageFromPath(
      url.pathname,
      languages
    );
    const browserUpgradePage = (_a = hostConfig.browserUpgradePage) == null ? void 0 : _a[language];
    const continueUrl = new URL(url.toString());
    deleteSimulatePageParam(continueUrl);
    deleteMaintenanceBypassParam(continueUrl);
    deleteConsolidatedLaunchedParam(continueUrl);
    const continueQueryParameter = encodeURIComponent(continueUrl.toString());
    const browserUpgradeUrl = `${browserUpgradePage.url}?continue=${continueQueryParameter}`;
    return {
      response: { ...browserUpgradePage, url: browserUpgradeUrl },
      ownershipInfo,
      simulatePage
    };
  }
  return {
    response: resolveOrigin(
      url,
      result.data,
      result.params,
      environment,
      replacementKeys.version,
      languages
    ),
    trailingSlashNormalization: result.data.trailingSlash,
    ownershipInfo,
    simulatePage
  };
};
var getOrigin = (hostConfig, inputUrl, request) => {
  const { response, trailingSlashNormalization, ownershipInfo, simulatePage } = getOutputResponse(hostConfig, inputUrl, request);
  if (trailingSlashNormalization) {
    const redirectPathname = normalizePathForTrailingSlashRedirect(
      inputUrl.pathname,
      trailingSlashNormalization
    );
    if (redirectPathname !== inputUrl.pathname) {
      const redirectUrl = new URL(inputUrl.toString());
      redirectUrl.pathname = redirectPathname;
      return {
        origin: {
          type: "redirect",
          url: redirectUrl.toString(),
          status: 307
        },
        ownershipInfo
      };
    }
  }
  return { origin: response, ownershipInfo, simulatePage };
};

// src/global-headers.ts
var jobseekerCookies = [
  {
    name: "JobseekerSessionId",
    maxAge: "31104000"
  },
  {
    name: "JobseekerVisitorId",
    maxAge: "157680000"
  }
];
var getNewJobseekerCookies = (request, globalCookieDomain) => {
  const cookies = getCookies(request);
  const newCookies = [];
  for (const { name, maxAge } of jobseekerCookies) {
    if (!(name in cookies)) {
      newCookies.push({
        name,
        maxAge,
        domain: globalCookieDomain,
        value: getJobseekerCookie(request, name)
      });
    }
  }
  return newCookies;
};
var applyRequestCookies = (request, newCookies) => {
  if (newCookies.length === 0) {
    return request;
  }
  let cookieHeader = request.headers.get("Cookie") || "";
  for (const { name, value } of newCookies) {
    const separator = cookieHeader ? "; " : "";
    cookieHeader = `${cookieHeader}${separator}${name}=${value}`;
  }
  request.headers.set("Cookie", cookieHeader);
  return request;
};
var applyResponseCookies = (response, newCookies) => {
  for (const { name, value, domain, maxAge } of newCookies) {
    response.headers.append(
      "Set-Cookie",
      `${name}=${value};Domain=${domain};Path=/;Max-Age=${maxAge}`
    );
  }
  return response;
};
var applyGlobalHeaders = (response) => {
  response.headers.append("strict-transport-security", "max-age=157680000");
  response.headers.append("seek-melways", "true");
  return response;
};

// src/handle-response.ts
function postProcessResponse(props) {
  downgradeRedirectCacheControlWhenLaunching(props);
}
function downgradeRedirectCacheControlWhenLaunching({
  res,
  hostConfig
}) {
  if (hostConfig.launching && (res.status === 301 || res.status === 308)) {
    let cacheControl = res.headers.get("Cache-Control");
    if (!(cacheControl == null ? void 0 : cacheControl.includes("no-store")) && !(cacheControl == null ? void 0 : cacheControl.includes("no-cache"))) {
      if (cacheControl == null ? void 0 : cacheControl.includes("max-age=")) {
        cacheControl = cacheControl.replace(/max-age=\d+/, "max-age=60");
        res.headers.set("Cache-Control", cacheControl);
      } else {
        res.headers.set("Cache-Control", "max-age=60");
      }
    }
  }
}

// src/handle-upstream-response.ts
var handleErrorOrigin = (errorOrigin, status) => {
  if ("htmlBody" in errorOrigin) {
    return new Response(errorOrigin.htmlBody, {
      status,
      headers: {
        "content-type": "text/html"
      }
    });
  }
  return fetch(errorOrigin.s3Url).then(
    (resp) => new Response(resp.body, {
      status,
      headers: {
        "content-type": "text/html"
      }
    })
  );
};
var getErrorStatus = (origin, responseStatus) => {
  if (origin.type === "ssr") {
    return { status: responseStatus };
  }
  if (origin.expectedToExist) {
    const message2 = `Expected file at ${origin.s3Url} to exist but could not find it`;
    return { status: 500, message: message2 };
  }
  const message = `Could not find file at ${origin.s3Url}`;
  return { status: 404, message };
};
var applyResponseHeaders = (response, responseHeaders = []) => {
  for (const [key, value] of responseHeaders) {
    response.headers.append(key, value);
  }
  return response;
};
var shouldSimulatePage = (origin, simulatePage) => simulatePage !== void 0 && simulatePage in errorStatusByType && (origin.type === "s3" || origin.type === "ssr");
var handleUpstreamResponse = (hostConfig, url, origin, response, ownershipInfo, simulatePage) => {
  if (shouldSimulatePage(origin, simulatePage)) {
    const errorStatus2 = errorStatusByType[simulatePage];
    const errorOrigin2 = generateErrorOrigin(url, hostConfig, simulatePage);
    return handleErrorOrigin(errorOrigin2, errorStatus2);
  }
  if (response.status >= 200 && response.status <= 399) {
    return applyResponseHeaders(response, origin.responseHeaders);
  }
  if (origin.type === "api") {
    return response;
  }
  const { status: errorStatus, message } = getErrorStatus(
    origin,
    response.status
  );
  if (message) {
    logError({ message, ownershipInfo });
  }
  const errorType = getErrorTypeByStatus(errorStatus);
  const errorOrigin = generateErrorOrigin(url, hostConfig, errorType);
  return handleErrorOrigin(errorOrigin, errorStatus);
};

// src/parse-url.ts
var import_melways_sites4 = require("@seek/melways-sites");
var ensureUrlObject = (url) => {
  if (url instanceof URL) {
    return url;
  }
  try {
    return new URL(url);
  } catch (e) {
    if (e instanceof Error && e.message.includes("is not a valid URL") && url.startsWith("/")) {
      throw new Error(
        "parseUrl needs a full URL including domain. Relative paths are not accepted."
      );
    }
    throw e;
  }
};
var parseUrlWithForcedSite = (url, site) => parseUrlWithOptionalSite(url, site);
var parseUrl = (url) => parseUrlWithOptionalSite(url);
var parseUrlWithOptionalSite = (url, site) => {
  const inputUrl = ensureUrlObject(url);
  let hostname;
  let siteName;
  if (site) {
    siteName = site;
    hostname = import_melways_sites4.siteConfig[site].host;
  } else {
    hostname = inputUrl.hostname;
    siteName = (0, import_melways_sites4.getSiteNameFromHostname)(inputUrl.hostname);
  }
  const config = import_melways_sites4.siteConfig[siteName];
  const { language = "en", pathWithoutLanguage } = getLanguageFromPath(
    inputUrl.pathname,
    config.languages
  );
  const locale = (0, import_melways_sites4.getLocale)(siteName, language);
  return {
    hostname,
    site: siteName,
    language,
    locale,
    pathWithoutLanguage,
    classification: config.classification,
    url: inputUrl
  };
};

// src/index.ts
var createRequestToOrigin = (originalRequest, environment, upstream, pathname) => {
  const url = new URL(originalRequest.url);
  const originalHost = url.host;
  url.host = istioGateways[environment];
  url.pathname = pathname;
  deleteSimulatePageParam(url);
  deleteMaintenanceBypassParam(url);
  deleteConsolidatedLaunchedParam(url);
  const upstreamRequest = new Request(url.toString(), originalRequest);
  upstreamRequest.headers.set("x-forwarded-host", originalHost);
  upstreamRequest.headers.set("seek-upstream-host", upstream);
  return upstreamRequest;
};
var createErrorResponse = async ({
  hostConfig,
  origin,
  request,
  status
}) => {
  const response = applyResponseHeaders(
    await handleErrorOrigin(origin, status),
    origin.responseHeaders
  );
  const newCookies = getNewJobseekerCookies(
    request,
    hostConfig.globalCookieDomain
  );
  const responseWithCookies = applyResponseCookies(response, newCookies);
  return applyGlobalHeaders(responseWithCookies);
};
var handleOrigin = async ({ origin, ownershipInfo, simulatePage }, hostConfig, url, request) => {
  switch (origin.type) {
    case "s3": {
      if (request.method !== "GET" && request.method !== "HEAD") {
        return new Response(null, {
          status: 405,
          statusText: "Invalid method"
        });
      }
      const upstreamResponse = await fetch(origin.s3Url, {
        method: request.method
      });
      const mutableResponse = new Response(
        upstreamResponse.body,
        upstreamResponse
      );
      const handledResponse = await handleUpstreamResponse(
        hostConfig,
        url,
        origin,
        mutableResponse,
        ownershipInfo,
        simulatePage
      );
      const newCookies = getNewJobseekerCookies(
        request,
        hostConfig.globalCookieDomain
      );
      const responseWithCookies = applyResponseCookies(
        handledResponse,
        newCookies
      );
      return applyGlobalHeaders(responseWithCookies);
    }
    case "ssr":
    case "api": {
      const upstreamRequest = createRequestToOrigin(
        request,
        origin.environment,
        origin.upstream,
        origin.pathname
      );
      const newCookies = getNewJobseekerCookies(
        request,
        hostConfig.globalCookieDomain
      );
      const upstreamRequestWithCookies = applyRequestCookies(
        upstreamRequest,
        newCookies
      );
      console.log("Upstream Request URL:", upstreamRequestWithCookies.url);
      console.log(
        "CF-IPCountry header sent:",
        upstreamRequestWithCookies.headers.get("cf-ipcountry")
      );
      const upstreamResponse = await fetch(upstreamRequestWithCookies);
      const mutableResponse = new Response(
        upstreamResponse.body,
        upstreamResponse
      );
      console.log("Upstream response code:", upstreamResponse.status);
      const handledResponse = await handleUpstreamResponse(
        hostConfig,
        url,
        origin,
        mutableResponse,
        ownershipInfo,
        simulatePage
      );
      const responseWithCookies = applyResponseCookies(
        handledResponse,
        newCookies
      );
      return applyGlobalHeaders(responseWithCookies);
    }
    case "redirect": {
      const redirectResponse = new Response(null, {
        status: origin.status,
        headers: {
          Location: origin.url
        }
      });
      const response = applyResponseHeaders(
        redirectResponse,
        origin.responseHeaders
      );
      const newCookies = getNewJobseekerCookies(
        request,
        hostConfig.globalCookieDomain
      );
      const responseWithCookies = applyResponseCookies(response, newCookies);
      return applyGlobalHeaders(responseWithCookies);
    }
    case "not-found":
    case "fallthrough": {
      if (origin.type === "fallthrough" || hostConfig.notFoundBehaviour === "fallthrough") {
        const awsIngressResponse = await fetch(
          createRequestToOrigin(
            request,
            hostConfig.environment,
            hostConfig.awsIngressUpstream,
            url.pathname
          )
        );
        if (awsIngressResponse.status !== errorStatusByType["not-found"]) {
          return awsIngressResponse;
        }
      }
      return createErrorResponse({
        hostConfig,
        origin: generateErrorOrigin(url, hostConfig, "not-found"),
        request,
        status: errorStatusByType["not-found"]
      });
    }
    case "forbidden":
    case "server-error":
    case "maintenance": {
      const status = errorStatusByType[origin.type];
      return createErrorResponse({ hostConfig, origin, request, status });
    }
  }
};
var handleRedirectOrigin = async (redirectUrl, status, hostConfig, url, request) => {
  const origin = {
    type: "redirect",
    url: redirectUrl.toString(),
    status
  };
  return handleOrigin({ origin }, hostConfig, url, request);
};
var handleMaintenanceOrigin = async (hostConfig, url, request) => {
  const origin = generateErrorOrigin(url, hostConfig, "maintenance", [
    ["Retry-After", getRetryAfterHeaderValue(hostConfig.maintenance)]
  ]);
  return handleOrigin({ origin }, hostConfig, url, request);
};
var route = async (request, url, hostConfig) => {
  let res;
  const result = getOrigin(hostConfig, url, request);
  const { origin, ownershipInfo, simulatePage } = result;
  const consolidationRedirectUrl = getConsolidationRedirectUrl(
    request,
    url,
    hostConfig,
    origin
  );
  if (consolidationRedirectUrl) {
    const { consolidatedSite } = import_melways_sites5.consolidationConfig[hostConfig.site].sitePair;
    const { launched } = import_melways_sites5.consolidationConfig[consolidatedSite];
    logFields({
      ...origin,
      ...ownershipInfo,
      simulatePage,
      maintenance: false,
      consolidation: true
    });
    res = await handleRedirectOrigin(
      consolidationRedirectUrl,
      launched ? 308 : 307,
      hostConfig,
      url,
      request
    );
  } else {
    const maintenance = await shouldShowMaintenance(
      request,
      url,
      hostConfig,
      origin
    );
    logFields({
      ...origin,
      ...ownershipInfo,
      simulatePage,
      maintenance,
      consolidation: false
    });
    res = maintenance ? await handleMaintenanceOrigin(hostConfig, url, request) : await handleOrigin(result, hostConfig, url, request);
  }
  postProcessResponse({ res, hostConfig });
  return res;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  getLanguageFromPath,
  getOrigin,
  parseUrl,
  parseUrlWithForcedSite,
  route
});
/*! Bundled license information:

cookie/index.js:
  (*!
   * cookie
   * Copyright(c) 2012-2014 Roman Shtylman
   * Copyright(c) 2015 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
//# sourceMappingURL=index.js.map